import { baseUrl } from "../api";

export const registrationTiersUrl = `${baseUrl}registration-tiers/`;
